import { Moon, Sun } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";

const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`group inline-flex h-10 w-10 items-center justify-center rounded-card border border-border bg-surface/50 text-foreground shadow-sm backdrop-blur-sm transition-all duration-layout hover:border-accent/40 hover:bg-surface hover:text-accent focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent ${className}`}
      aria-label={isDark ? "מצב בהיר" : "מצב כהה"}
      title={isDark ? "מצב בהיר" : "מצב כהה"}
    >
      {isDark ? (
        <Sun className="h-[18px] w-[18px] transition-transform duration-layout group-hover:rotate-12" />
      ) : (
        <Moon className="h-[18px] w-[18px] transition-transform duration-layout group-hover:-rotate-12" />
      )}
    </button>
  );
};

export default ThemeToggle;
